import { IWorkDuration } from 'src/types/workDuration';

export const WORK_DURATION: IWorkDuration = {
    totalWorkDuration: '12d 23h 45m',
    averageTaskDuration: '1h 45m',
    netWorkTime: '1h 45m',
    latencyTime: '1h 45m',
    codingTime: '6h 32m',
    codeReviewTime: '22m',
    qaTime: '2h 1m',
    idleTime: '13h 2m',
    averageDelegationTime: '2h 57m',
    percentageTimeWithoutWork: '45%',
    taskVelocity: '1h 45m',
    workVelocity: '1h 45m'
};
